export const ROLES = {
  ADMIN: 'admin',
  REGULATOR: 'regulator',
  DEMO: 'demo',
  B2C_USER: 'b2c_user'
}
